import { AbstractIconComponent } from './abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-aaa',
  templateUrl: './aaa.icon.html',
})
export class AaaIconComponent extends AbstractIconComponent {
  static icon = 'aaa'
}
